module.exports = __webpack_public_path__ + "img/radar.66ea004f.png";